var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,227.7c-7.8-7.8-7.8-20.5,0-28.3L174.4,82.3c7.8-7.8,20.5-7.8,28.3,0l73.6,73.6l116-116h-51.4 c-11,0-20-9-20-20s9-20,20-20h99.6c11.2,0,20,9.2,20,20v99.7c0,11-9,20-20,20s-20-9-20-20V68.3L290.5,198.4 c-7.8,7.8-20.5,7.8-28.3,0l-73.6-73.6l-103,103C77.8,235.5,65.1,235.5,57.3,227.7L57.3,227.7z M142.9,374v118c0,11-9,20-20,20H20 c-11,0-20-9-20-20V374c0-11,9-20,20-20h102.9C133.9,354,142.9,363,142.9,374z M102.9,394H40v78h62.9V394z M327.4,297.9V492 c0,11-9,20-20,20H204.6c-11,0-20-9-20-20V297.9c0-11,9-20,20-20h102.9C318.5,277.9,327.4,286.9,327.4,297.9z M287.4,317.9h-62.9V472 h62.9V317.9z M512,221.9V492c0,11-9,20-20,20H389.1c-11,0-20-9-20-20V221.9c0-11,9-20,20-20H492C503,201.9,512,210.8,512,221.9z  M472,241.9h-62.9V472H472V241.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.7ed998bf9906390c492c797d9540022d.svg";
export { ForwardRef as ReactComponent };